import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 149.46 181.49"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M95.65 181.47c-8.29 0-16.64-1.09-24.86-3.29-24.63-6.59-45.22-22.4-57.96-44.47C.08 111.62-3.31 85.89 3.29 61.26c6.6-24.63 22.4-45.22 44.49-57.96L53.49 0l-.2 6.3c-.03.38-3.5 38.87 25.6 89.28 29.11 50.41 64.17 66.64 64.52 66.8l6.05 2.73-6.22 3.56c-14.7 8.49-31.03 12.82-47.57 12.82l-.02-.02ZM46.34 12.15C28.16 24.31 15.42 42.09 9.81 63.01c-6.13 22.89-2.98 46.8 8.86 67.32 11.85 20.52 30.98 35.19 53.87 41.32 21.07 5.64 42.98 3.43 62.33-6.19-11.56-6.81-38.36-25.85-61.85-66.52C49.55 58.3 46.46 25.58 46.33 12.15Z",
  style: {"fill":"#181716"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }